import React from 'react';

export default class Options extends React.Component {
  render() {
    return <div className="content">
      <h1 className="title is-3">What Options Should I Consider?</h1>
      <img src="/assets/images/step+3.jpeg" />
      <p>Engaged patients will benefit by asking for options.  While its acceptable to request the clinician's single best recommendation, there is almost always more than one way to proceed.  Since each option has its pros and cons, taking the time to learn about more than one will give you the advantage of comparing and contrasting options from your own perspective.</p>
    </div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/more/Options.js